import { useState } from 'react'
import { ProtectedRoute } from '@/components/auth/protected-route'

function SettingsPage() {
  const [activeTab, setActiveTab] = useState('preferences')
  
  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-background p-4 md:p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-text mb-8">Settings</h1>
          
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            {/* Sidebar navigation */}
            <div className="md:col-span-3">
              <nav className="space-y-1 sticky top-8">
                <TabButton 
                  isActive={activeTab === 'preferences'} 
                  onClick={() => setActiveTab('preferences')}
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-5 w-5 mr-3" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" 
                    />
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" 
                    />
                  </svg>
                  Preferences
                </TabButton>
                <TabButton 
                  isActive={activeTab === 'notifications'} 
                  onClick={() => setActiveTab('notifications')}
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-5 w-5 mr-3" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" 
                    />
                  </svg>
                  Notifications
                </TabButton>
                <TabButton 
                  isActive={activeTab === 'privacy'} 
                  onClick={() => setActiveTab('privacy')}
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-5 w-5 mr-3" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" 
                    />
                  </svg>
                  Privacy
                </TabButton>
              </nav>
            </div>
            
            {/* Main content */}
            <div className="md:col-span-9">
              {activeTab === 'preferences' && (
                <div className="p-6 bg-card rounded-lg border border-border animate-fadeIn">
                  <h2 className="text-xl font-bold text-text mb-4">Preferences</h2>
                  <p className="text-text/70">Preferences settings will be available soon.</p>
                </div>
              )}
              
              {activeTab === 'notifications' && (
                <div className="p-6 bg-card rounded-lg border border-border animate-fadeIn">
                  <h2 className="text-xl font-bold text-text mb-4">Notifications</h2>
                  <p className="text-text/70">Notification settings will be available soon.</p>
                </div>
              )}
              
              {activeTab === 'privacy' && (
                <div className="p-6 bg-card rounded-lg border border-border animate-fadeIn">
                  <h2 className="text-xl font-bold text-text mb-4">Privacy</h2>
                  <p className="text-text/70">Privacy settings will be available soon.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  )
}

interface TabButtonProps {
  isActive: boolean
  onClick: () => void
  children: React.ReactNode
}

function TabButton({ isActive, onClick, children }: TabButtonProps) {
  return (
    <button 
      onClick={onClick}
      className={`flex w-full items-center px-4 py-3 text-text rounded-md border-l-4 transition-colors ${
        isActive 
          ? 'bg-primary/10 border-primary' 
          : 'border-transparent hover:bg-gray-800/50'
      }`}
    >
      {children}
    </button>
  )
}

export { SettingsPage }
